import request from './request';

const DEFAULT_RELATIONSHIPS = ['recipients'];

export async function get(crowdpacId, query) {
  return await request('get', `/apiv2/crowdpac/${crowdpacId}`, query);
}

export async function contactSupport(crowdpacId, { email, subject, message }) {
  return await request('post', `/apiv2/crowdpac/${crowdpacId}/help`, { email, subject, message });
}

export async function additionalData(crowdpacId, data) {
  return await request('get', `/apiv2/crowdpac/${crowdpacId}/additional-data`, data);
}

export function getMaximumContributionAmount(crowdpac) {
  if (crowdpac.relationships && crowdpac.relationships.donation_form_recipients) {
    return crowdpac.relationships.donation_form_recipients.reduce((total, recipient) => {
      const recipientLimit = recipient.recipient.contribution_limit;
      // If one candidate doesn't have a limit, neither does the entire campaign.
      return total + (recipientLimit > 0 ? recipientLimit : Infinity);
    }, 0);
  } else {
    throw new Error('To get a contribution max, the crowdpac must have the `donation_form_recipients` relationship.');
  }
}

export async function setUpDemocracyEngineAccount(input) {
  const payload = new FormData();

  payload.append('crowdpac_id', input.crowdpacId);
  payload.append('recipient_type', input.recipientType);
  payload.append('recipient_id', input.recipientId);

  payload.append('filler_name', input.fillerName);
  payload.append('filler_email', input.fillerEmail);
  payload.append('committee_name', input.committeeName);
  payload.append('recipient_name', input.recipientName);
  payload.append('finances_name', input.financesName);
  payload.append('finances_address_1', input.financesAddress1);
  payload.append('finances_address_city', input.financesAddressCity);
  payload.append('finances_address_state', input.financesAddressState);
  payload.append('finances_address_zip', input.financesAddressZip);
  payload.append('finances_dob', input.financesDob);
  payload.append('finances_ssn', input.financesSsn);

  if (input.receiveFundsMethod === 'ach') {
    payload.append('ach_bank_name', input.achBankName);
    payload.append('bank_account_type', input.bankAccountType);
    payload.append('ach_routing_number', input.achRoutingNumber);
    payload.append('ach_account_number', input.achAccountNumber);
    payload.append('bank_verification_file', input.bankVerificationFile);
  } else if (input.receiveFundsMethod === 'check') {
    payload.append('address_1', input.address1);
    payload.append('address_2', input.address2);
    payload.append('address_city', input.addressCity);
    payload.append('address_state', input.addressState);
    payload.append('address_zip', input.addressZip);
  }

  return await request('post', '/apiv2/finances/store', payload);
}

export async function relatedCrowdpac(id) {
  return await request('get', `/apiv2/crowdpac/${id}/related`, {});
}

export async function createdCampaigns() {
  return await request('get', `/apiv2/crowdpac/created`, {});
}

export async function handleTotals(id, params) {
  return await request('put', `/apiv2/crowdpac/${id}/hide-totals`, params);
}

export async function handleRecentDonations(id, params) {
  return await request('put', `/apiv2/crowdpac/${id}/hide-recent-donations`, params);
}

export async function featuredCampaigns() {
  return await request('get', `/apiv2/crowdpac/featured`, {});
}